const WSMTypes = [{ key: 'NG', label: 'Nginx' }];

export default Object.freeze(WSMTypes);
